import { ApiPath } from '../api/ApiPath';
import { useCallback } from 'react';
import { api } from '../functions/api';

export function useApiPromiseFn<T>(url: ApiPath, params?: any): () => Promise<T> {
  return useCallback(() => api({ url, params }), [url, params]);
}
